import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'deleteManyAlternativeCampaign'

export default (codeIds) => (asyncAction(
  name,
  ExtraCampaignsService.deleteManyAlternativeCampaign,
  { codeIds }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/deleteManyAlternativeCampaign.js